import { isNotNullish } from './types';

export type EnumMap<E extends string, T> = {
	[k in E]: T;
}

export function isEnum<T, Y extends T[keyof T]>(_: unknown, theEnum: T): _ is Y {
	return (isNotNullish(_) && Object.values(theEnum).includes(_));
}

export function stringToEnum<T, Y extends T[keyof T]>(x: unknown, theEnum: T, defaultVal: Y): Y {
	return isEnum<T, Y>(x, theEnum) ? x : defaultVal;
}
